var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-6.2271577,-37.553193)","id":"layer1"},React.createElement("path",{"style":{"fill":"#1008bd","fillOpacity":"1","strokeWidth":"0.264583"},"d":"m 11.247309,37.553193 -2.1758808,2.171117 -2.1758545,-2.171117 -0.668416,0.66839 2.8442705,2.844271 2.8442708,-2.844271 z","fill":"#ffffff","id":"path4"})));
}

Chevron.defaultProps = {"id":"svg29","version":"1.1","viewBox":"0 0 5.6885414 3.512661","height":"3.512661mm","width":"5.6885414mm"};

module.exports = Chevron;

Chevron.default = Chevron;
